import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SiteDataProvider } from "@/context/SiteDataContext";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Enquiries from "@/pages/admin/Enquiries";
import LeadDetail from "@/pages/admin/LeadDetail";
import Bookings from "@/pages/admin/Bookings";
import Customers from "@/pages/admin/Customers";
import PackagesAdmin from "@/pages/admin/PackagesAdmin";
import Quotes from "@/pages/admin/Quotes";
import QuoteBuilder from "@/pages/admin/QuoteBuilder";
import Settings from "@/pages/admin/Settings";
import AutoMessages from "@/pages/admin/AutoMessages";
import Reminders from "@/pages/admin/Reminders";
import Briefings from "@/pages/admin/Briefings";
import Feedback from "@/pages/admin/Feedback";
import Automation from "@/pages/admin/Automation";
import Reviews from "@/pages/admin/Reviews";
import GuestReviews from "@/pages/GuestReviews";
import FerryBooking from "@/pages/FerryBooking";
import HotelBooking from "@/pages/HotelBooking";
import WaterActivitiesPage from "@/pages/WaterActivities";
import CategoryLanding from "@/pages/CategoryLanding";

const LANDING_KINDS = ["honeymoon", "family", "budget", "premium", "luxury"];

function App() {
  return (
    <BrowserRouter>
      <SiteDataProvider>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/packages/:slug" element={<PackageDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reviews" element={<GuestReviews />} />
            <Route path="/ferry-booking" element={<FerryBooking />} />
            <Route path="/hotel-booking" element={<HotelBooking />} />
            <Route path="/water-activities" element={<WaterActivitiesPage />} />
            {LANDING_KINDS.map((k) => <Route key={k} path={`/andaman-${k}-packages`} element={<CategoryLanding kind={k} />} />)}
            <Route path="/share-your-trip" element={<Navigate to="/reviews#write" replace />} />
          </Route>
          <Route path="/admin" element={<AuthProvider><Outlet /></AuthProvider>}>
            <Route path="login" element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="enquiries" element={<Enquiries />} />
              <Route path="bookings" element={<Bookings />} />
              <Route path="reminders" element={<Reminders />} />
              <Route path="briefings" element={<Briefings />} />
              <Route path="feedback" element={<Feedback />} />
              <Route path="automation" element={<Automation />} />
              <Route path="auto-messages" element={<AutoMessages />} />
              <Route path="reviews" element={<Reviews />} />
              <Route path="customers" element={<Customers />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="packages" element={<PackagesAdmin />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="quotes/new" element={<QuoteBuilder />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Route>
        </Routes>
      </SiteDataProvider>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}

export default App;
